import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CategoryPage from '../Scenes/Admin/CategoryPage/CategoryPage';
import CampaignPage from '../Scenes/Admin/CampaignPage/CampaignPage';
import DiscountsPage from '../Scenes/Admin/DiscountsPage/DiscountsPage';
import ProductCatalog from '../Scenes/Admin/ProductCatalog/ProductCatalog';
import CartsPage from '../Scenes/Admin/CartsPage/CartsPage';
import EditProduct from '../Scenes/Admin/ProductCatalog/EditProduct/EditProduct';
import CreateProduct from '../Scenes/Admin/ProductCatalog/CreateProduct/CreateProduct';
import RefillsPage from '../Scenes/Admin/RefillsPage/RefillsPage';

const AdminRoutes = () => {
  return (
    <Switch>
      <Route path="/admin/campaigns" exact>
        <CampaignPage />
      </Route>
      <Route path="/admin/categories" exact>
        <CategoryPage />
      </Route>
      <Route path="/admin/product-catalog" exact>
        <ProductCatalog />
      </Route>
      <Route path="/admin/product-catalog/edit/:id">
        <EditProduct />
      </Route>
      <Route path="/admin/discounts" exact>
        <DiscountsPage />
      </Route>
      <Route path="/admin/carts" exact>
        <CartsPage />
      </Route>
      <Route path="/admin/product-catalog/create" exact>
        <CreateProduct />
      </Route>
      <Route path="/admin/refills" exact>
        <RefillsPage />
      </Route>
    </Switch>
  );
};

export default AdminRoutes;
